import { Component, ElementRef, OnInit, ViewChild, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, take, takeUntil } from 'rxjs';
import { VenueModel } from 'src/app/pos-panel/models/venues/venue.model';
import { VenueService } from 'src/app/pos-panel/services/venues/venue.service';
import { CompressImageService } from 'src/app/share-modul/services/common/compress-image.service';
import { CreateCapacityForVenuesComponent } from "../create-capacity-for-venues/create-capacity-for-venues.component";
import { CreateOrEditCapacityModel } from "../../../models/tables/create-or-edit-capacity.model";

declare const google: any;

@Component({
  selector: 'app-addoreditvenues',
  templateUrl: './addoreditvenues.component.html',
  styleUrls: ['./addoreditvenues.component.scss']
})
export class AddOrEditVenuesComponent implements OnInit, OnDestroy, AfterViewInit {

  //#region Fields
  @ViewChild('search') searchElementRef: ElementRef;
  public unsubscribe: Subject<void> = new Subject<void>();
  public pictureIsWrongFormat: boolean = false;
  public venueModel: VenueModel = new VenueModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/logo/venuelogo.png';
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public venueId: string;
  public enableEdit: boolean = false;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public capacityConfig: CreateOrEditCapacityModel;
  public invalidAddressMessage = "INFO.INVALID_ADDRESS";
  public autocomplete: google.maps.places.Autocomplete;
  //#endregion

  //#region Constructor
  constructor(
    private openFile: ElementRef,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    public dialogService: DialogService,
    private venueService: VenueService,
    private messageService: MessageService,
    private compressImage: CompressImageService,
    private ngZone: NgZone
  ) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];

    if (this.config.data != undefined && this.config.data.id) {
      this.venueId = this.config.data.id
      this.enableEdit = true;
      this.getVenueById(this.venueId);
    }
  }

  ngOnInit(): void {
  }

  public ngAfterViewInit(): void {
    this.findAddress();
  }
  //#endregion

  //#region Public Methods
  public addVenue(model: VenueModel): void {
    this.errorModel = {}
    if (model && model.name == "") {
      this.errorModel['name'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.phone) {
      this.errorModel['phone'] = this.requiredFieldErrorMessage;
    }
    if (model && model.address == "") {
      this.errorModel['adress'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.latitude || !model.longitude)) {
      this.errorModel['adress'] = this.invalidAddressMessage;
    }
    if (Object.keys(this.errorModel).length === 0) {

      model.capacityConfig = this.capacityConfig;
      model.phone = model.phone.toString();

      this.spinner = true;
      this.venueService.addvenue(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
          }
        });
    }
  }

  public updateVenue(model: VenueModel): void {
    this.errorModel = {}
    if (model && model.name == "") {
      this.errorModel['name'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.phone) {
      this.errorModel['phone'] = this.requiredFieldErrorMessage;
    }
    if (model && model.address == "") {
      this.errorModel['adress'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.latitude || !model.longitude)) {
      this.errorModel['adress'] = this.invalidAddressMessage;
    }
    if (Object.keys(this.errorModel).length === 0) {

      model.capacityConfig = this.capacityConfig;
      model.phone = model.phone.toString();

      this.spinner = true;
      this.venueService.updatevenue(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
          }
        });
    }
  }


  public getVenueById(venueId: string): void {
    this.spinner = true;
    this.venueService.getvenuedetails(venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.venueModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  public cancel(): void {
    this.ref.close(false);
  }

  public openAddImage(): void {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }

  public onFileSelected(event: any): void {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return;
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {
          this.filePicture = compressedImage;
        })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.venueModel.pictureUrl = item.target?.result as string;
        }
      }
    }
  }

  public createCapacityForVenue(): void {
    const ref = this.dialogService.open(CreateCapacityForVenuesComponent, {
      data: {
        id: this.venueId,
        returnCapacityObject: true,
        capacityConfig: this.capacityConfig
      },
      width: '1000px'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.capacityConfig = item;
      }
    });
  }

  public findAddress(): void {
      this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      this.autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          this.errorModel['adress'] = null;
          let place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
          if (!place || !place.geometry) {
            this.errorModel['adress'] = this.invalidAddressMessage;
            return;
          }
          if (place.formatted_address) {
            this.venueModel.address = place.formatted_address;
          }
          this.venueModel.latitude = place.geometry?.location.lat();
          this.venueModel.longitude = place.geometry?.location.lng();
        });
      });
  }

  public onAddressManualChange(): void {
    this.venueModel.latitude = undefined;
    this.venueModel.longitude = undefined;
  }

  public ngOnDestroy(): void {
    this.autocomplete.unbindAll();
    google.maps.event.clearInstanceListeners(this.autocomplete);
    const elements = document.querySelectorAll('.pac-container');
    elements.forEach((element) => {
      element.remove();
    });
  }
  //#endregion
}
